import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { LiveNursesService } from 'src/app/recruiting/candidates/live-nurses-new/live-nurses.service';
import * as actions from 'src/app/recruiting/candidates/live-nurses-new/store/live-nurses.actions';
import { ToasterService } from 'src/app/shared/services/toaster.service';

@Injectable()
export class SubmittalNotesEffect {
    getSubmittalNotes$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.loadNotesForSubmittal),
            switchMap((action) => {
                return this.liveNursesService.getSubmittalNotes(action.submittalId).pipe(
                    map((response) =>
                        actions.loadNotesForSubmittalSuccess({
                            notes: response
                        })
                    ),
                    catchError((error) => of(actions.loadNotesForSubmittalFail({ error })))
                );
            })
        )
    );

    getSubmittalNotesFail$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(actions.loadNotesForSubmittalFail),
                tap((action) => {
                    console.log(action.error);
                    this.toaster.toast('Sorry. A problem occurred while loading Submittal Notes.');
                })
            ),
        { dispatch: false }
    );

    constructor(
        private actions$: Actions,
        protected liveNursesService: LiveNursesService,
        private toaster: ToasterService
    ) {}
}
